// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"TogglePaymentButton_applePayButton__BT6SR","logo":"TogglePaymentButton_logo__2xbyp"};